import React, { useEffect } from 'react';

import { useHistory, useParams } from "react-router-dom";

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
    iframe: {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: theme.palette.grey[100],
        width: 620,
        maxWidth: '100%',
        height: 700,
        [theme.breakpoints.up('md')]: {
            marginLeft: 10
        }
    },
    infoPanel: {
        [theme.breakpoints.up('md')]: {
            maxWidth: 350,
            borderRightWidth: 1,
            borderRightStyle: 'solid',
            borderRightColor: theme.palette.grey[100],
        },
    }
}));

const SentEmailWrapper = (props) => {
    const {
        email,
    } = props;

    const classes = useStyles();

    return (
        <Grid
            container
            spacing={1}
        >
            <Grid item xs={12} md className={classes.infoPanel}>
                <Box mb={1}>
                    <Typography><b>Subject:</b> {email.subject}</Typography>
                </Box>
                <Box mb={1}>
                    <Typography><b>To:</b> {Object.keys(email.to).join(', ')}</Typography>
                    <Typography><b>From:</b> {Object.keys(email.from).join(', ')}</Typography>
                    <Typography><b>Cc:</b> {email.cc ? Object.keys(email.cc).join(', ') : ''}</Typography>
                </Box>
                <Typography><b>Date sent:</b> {email.date_sent}</Typography>
            </Grid>
            <Grid item xs={12} md>
                <Grid container>
                    <Box mx='auto'>
                        <iframe className={classes.iframe} src={`/admin/emails/${email.id}/preview`} />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    )
}

const SentEmail = () => {
    const { id } = useParams();
    const classes = useStyles();

    const [email, setEmail] = React.useState({});

    const history = useHistory();
    function handleBackClick() {
        history.push('/admin/emails');
    }

    useEffect(() => {
        document.title = `Sent Email ${id} - Enduring Promises`;

        /* TODO: add loader? */

        new Promise((resolve, reject) => {
            let url = `/api/emails/sent/${id}`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setEmail(result);
                    resolve();
                })
        });
    }, [id]);

    return (
        <div>
            <Box mb={2}>
                <Button startIcon={<Icon>chevron_left</Icon>} size="small" onClick={handleBackClick} variant="outlined" color="primary">Back</Button>
            </Box>
            <Paper square>
                <Box className={classes.root}>
                    {email.id !== undefined && <SentEmailWrapper email={email} />}
                </Box>
            </Paper>
        </div>
    );
}

export default SentEmail;
